/**
 *
 * @type {string}
 */
export const BASE_URL = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : 'https://api.rushdelivery.app';
export const BASE_URL_WS = BASE_URL.replace('http', 'ws');

/**
 * When false, the website is browse-only (menu). Customers must order from the mobile app.
 * Flip to true to re-enable web cart / checkout.
 */
export const WEB_ORDERING_ENABLED = false;
